exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root {\n  fill: '#8899A6';\n}\n", ""]);
